import { expenseRequestUrls } from "@/utils/messageUrl";
import http from "./httpVideo";
import { BaseResponseType, MessageDetailType, MessageListType, OrderParamsType, PaymentOrderParamsType } from "@/types/message";




const {get,post}=http;


const baseUrlPerfix='/buyer';






/**
 * 获取 可用余额
 * @returns 
 */
export const getAccountOverviewWallet=():Promise<BaseResponseType>=>{
  return get(expenseRequestUrls.getAccountOverviewWallet)
}

/**
 * 获取开票金额
 * @returns 
 */
export const getAccountOverviewInvoiceMoney=():Promise<BaseResponseType>=>{
  return get(expenseRequestUrls.getAccountOverviewInvoiceMoney)
}

/**
 * 获取待支付已支付订单列表
 * @param params 
 * @returns 
 */
export const getAccountOrderList=(params:OrderParamsType):Promise<BaseResponseType>=>{
  return get(expenseRequestUrls.getAccountOrderList,{params})
}

/**
 * 创建充值订单
 * @param params 
 * @returns 
 */
export const createRechargeOrder=(params:any):Promise<BaseResponseType>=>{
  return post(expenseRequestUrls.createRechargeOrder,params,{
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    }, 
  })
}

/**
 * 上报 对公汇款户名
 * @param params 
 * @returns 
 */
export const sendremitAccountName=(params:any):Promise<BaseResponseType>=>{
  return post(expenseRequestUrls.sendremitAccountName,params)
}

/**
 * 支付
 * @param params 
 * @returns 
 */
export const paymentForOrder=(params:PaymentOrderParamsType):Promise<BaseResponseType>=>{
  return get(`${expenseRequestUrls.paymentForOrder}/${params.paymentMethod}/${params.paymentClient}`,{params})
}

/**
 * 获取发票开票记录
 * @returns 
 */
export const getInoviceRecords=():Promise<BaseResponseType>=>{
  return get(expenseRequestUrls.getInoviceRecords)
}


/**
 * 计算发票开票金额
 * @param params 
 * @returns 
 */
export const calcuateOrderAmount=(params:any):Promise<BaseResponseType>=>{
  console.log('calcuateOrderAmount',params)
  return get(expenseRequestUrls.calcuateOrderAmount+'?orderSns='+params)
}


/**
 * 提交开票信息
 * @param params 
 * @returns 
 */
export const submitInvoice=(params:any):Promise<BaseResponseType>=>{
  return post(expenseRequestUrls.submitInvoice,params,{
    headers:{
      'Content-Type':'application/x-www-form-urlencoded'
    }, 
  })
}


/**
 * 校验余额是否够支付
 * @param params 
 * @returns 
 */
export const checkWalletForOrder=(params:any):Promise<BaseResponseType>=>{
  return get(expenseRequestUrls.checkWalletForOrder,{params})
}

/**
 * 获取支付结果
 * @param params 
 * @returns 
 */
export const getPaymentResult=(params:PaymentOrderParamsType):Promise<BaseResponseType>=>{
  return get(expenseRequestUrls.getPaymentResult,{params})
}